
import { Component, Vue } from 'vue-property-decorator'
import { Tree } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import { sysMenuDTO, GtRoleMenu, getMenuListByCykj, DistributeMenu, updateRoleName } from '@/api/roles'

@Component({
  components: {Tree}
})
export default class RoleRules extends Vue {

  roleId = '' // 角色ID
  roleName = '' // 角色名称
  isAdministrator = true // 是否是管理员 管理员权限不可修改
  selectMenus: string[] = []
  halfCheckedKeys: string[] = [] // 半选状态的key
  powerList: sysMenuDTO[] = []
  editState = false

  isChange = false //控制用户是否改变权限

  replaceFields = {
    children: 'children',
    title: 'menuName',
    key: 'menuId',
  }

  created () {
    this.roleId = this.$route.query.roleId as string
    this.roleName = this.$route.query.roleName as string
    this.isAdministrator = this.$route.query.isAdministrator as string === '0'
    this.getMenuTreeList()
  }

  handleBack () {
    this.$router.go(-1)
  }

  async getMenuTreeList () {
    await getMenuListByCykj({}).then(res => {
      this.powerList = []
      // 判断公司是否为核心企业
      let isCusMerchantLoan = this.$store.state.user.isCusMerchantLoan
      let haveAuditPermission = this.$store.state.user.haveAuditPermission
      // 非核心企业，权限列表中不展示【客户借款】
      if(!isCusMerchantLoan){
         res.data[0].children[0].children = res.data[0].children[0].children.filter(
          (item: any) => {
            return item.actionName !== 'customerLoan'
          }
        )
      }
      // 权限列表中不展示【产业合作】
      if(!haveAuditPermission){
         res.data[0].children[0].children = res.data[0].children[0].children.filter(
          (item: any) => {
            return item.actionName !== 'industrialCooperation'
          }
        )
      }
      this.powerList.push(res.data[0].children[0])
      this.powerList.push(res.data[1].children[0])
      this.powerList.map(item => {
        item.slots = {icon: 'meh'}
      })
    })
    this.getRoleMenu()
  }


  // 获取当前选中角色的权限
  getRoleMenu () {
    GtRoleMenu({roleId: this.roleId}).then(res => {
      let datas: { menuId: string }[] = res.data || []
      this.selectMenus = datas.map(item => item!.menuId)
      this.halfCheckedKeys = []
      this.handleHalfSelects(this.powerList)
    })
  }

  handleHalfSelects (menus: sysMenuDTO[]) {
    menus.map(menu => {
      if (this.selectMenus.includes(menu.menuId)) {
        this.halfCheckedKeys.push(menu.menuId)
      }
      if (menu.children && menu.children.length > 0) {
        this.handleHalfSelects(menu.children)
      }
    })
  }


  onCheck (checkKeys: string[], {halfCheckedKeys}: any) {
    this.halfCheckedKeys = halfCheckedKeys
    this.isChange = true
  }

  /**
   * 点击保存
   */
  async addSure () {
    // if (!this.$action('edit')) {
    //   return false
    // }
    (this.$refs.roles as any).validate().then(() => {
      if (this.roleId === '') {
        this.$message.error('未选择需要修改的角色')
        return false
      }
      // 处理半选和全选节点
      const data = this.selectMenus.map(i => ({
        id: i,
        halfChecked: false
      })).concat(this.halfCheckedKeys.map(i => ({
        id: i,
        halfChecked: true
      })))
      if (data.length === 0) {
        this.$message.error('权限列表至少勾选一项')
        return false
      }
      let params = {
        roleId: this.roleId,
        menuIds: data
      }
      if(this.roleName !== (this.$route.query.roleName as string)&&!this.isChange){
        updateRoleName({roleName: this.roleName, roleId: this.roleId}).then(() => {
          this.$toast({
            type: 'success',
            message: '修改成功',
            duration: 1000,
            onClose: () => {
              // 刷新订单信息对象shouhuo
              this.$router.back()
            }
          })
        }).catch(() => {
          this.$toast('修改角色名称失败')
        })
      }
      else if (this.isChange){
        DistributeMenu(params).then(() => {
          if (this.roleName !== (this.$route.query.roleName as string)) {
            updateRoleName({roleName: this.roleName, roleId: this.roleId}).then(() => {
              this.$toast({
                type: 'success',
                message: '修改成功',
                duration: 1000,
                onClose: () => {
                  // 刷新订单信息对象shouhuo
                  this.$router.back()
                }
              })
            }).catch(() => {
              this.$toast('修改角色名称失败')
            })
          } else {
            this.$toast({
              type: 'success',
              message: '修改成功',
              duration: 1000,
              onClose: () => {
                // 刷新订单信息对象shouhuo
                this.$router.back()
              }
            })
          }
        }).catch(() => {
          this.$toast('修改角色权限失败')
        })
      }
    })
  }
}
